export enum TimePeriodOptions {
    LAST_24_HOURS = 'last_24_hours',
    LAST_7_DAYS = 'last_7_days',
    LAST_30_DAYS = 'last_30_days',
    LAST_3_MONTHS = 'last_3_months',
    LAST_6_MONTHS = 'last_6_months',
    LAST_1_YEAR = 'last_1_year',
};
